"use client";
import { Bike, Users, MapPin, Award, Clock, Leaf, Star } from "lucide-react";
import CommonLayout from "@/components/home/CommonLayout";

// interface CounterProps {
//   end: number;
//   duration: number;
//   suffix?: string;
// }

const brandName = "rideNgo";

// const Counter: React.FC<CounterProps> = ({ end, duration, suffix = "" }) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let startTime: number;
//     const startCount = 0;

//     const updateCount = (timestamp: number) => {
//       if (!startTime) startTime = timestamp;
//       const progress = Math.min((timestamp - startTime) / duration, 1);
//       setCount(Math.floor(progress * (end - startCount) + startCount));

//       if (progress < 1) {
//         requestAnimationFrame(updateCount);
//       }
//     };

//     requestAnimationFrame(updateCount);
//   }, [end, duration]);

//   return (
//     <span>
//       {count.toLocaleString()}
//       {suffix}
//     </span>
//   );
// };

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  delay: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  description,
  delay,
}) => (
  <div
    className={`group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 ${delay} animate-fade-in-up border border-gray-100`}
  >
    <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
      {icon}
    </div>
    <h3 className="text-xl font-bold text-gray-800 mb-4">{title}</h3>
    <p className="text-gray-600 leading-relaxed">{description}</p>
  </div>
);

const AboutUsClient: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white relative overflow-x-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-20 left-10 w-4 h-4 bg-orange-400 rounded-full animate-bounce"></div>
          <div className="absolute top-40 right-20 w-3 h-3 bg-cyan-400 rounded-full animate-pulse"></div>
          <div className="absolute bottom-32 left-1/4 w-2 h-2 bg-purple-400 rounded-full animate-ping"></div>
        </div>
        <div className="absolute inset-0">
          <svg
            viewBox="0 0 1440 320"
            className="absolute bottom-0 w-full h-auto"
          >
            <path
              fill="rgba(249, 115, 22, 0.1)"
              d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,149.3C672,139,768,149,864,165.3C960,181,1056,203,1152,197.3C1248,192,1344,160,1392,144L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>

        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center animate-pulse">
            <Bike className="w-10 h-10 text-white" />
          </div>
        </div>

        <div className="relative max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8 w-full min-w-0">
          <div className="animate-fade-in-up">
            <h2 className="text-2xl sm:text-4xl md:text-6xl font-bold mb-8 break-words">
              About
              <span className="text-orange-400">&nbsp;{brandName}&nbsp;</span>
              Journey?
            </h2>
            <p className="text-base sm:text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed px-1">
             RidenGo aims to create best in class rental experience with focus on customer satisfaction, carefree riding and making the journey memorable.
            </p>
          </div>
        </div>
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <Bike className="w-12 h-12 text-white/60" />
        </div>
      </section>

      {/* Story Section */}
      <CommonLayout className="py-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="animate-fade-in-left">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-8 break-words">
              Revolutionizing
              <span className="text-orange-500"> Mobility</span> Across India
            </h2>
            {/* <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Founded with a vision to make quality transportation accessible to
              everyone, {brandName} has grown from a small startup to
              India&apos;s leading bike rental platform, serving customers
              across 40+ cities.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Whether you need a quick ride for daily commute or an adventure
              bike for your weekend getaway, we provide reliable, affordable,
              and well-maintained vehicles starting from just ₹399 per day.
            </p> */}
            {/* <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div className="text-3xl font-bold text-blue-600 mb-2">40+</div>
                <div className="text-gray-600">Cities Covered</div>
              </div>
              <div className="text-center p-4 bg-orange-50 rounded-lg">
                <div className="text-3xl font-bold text-orange-600 mb-2">
                  ₹399
                </div>
                <div className="text-gray-600">Starting Price/Day</div>
              </div>
            </div> */}
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 bg-green-100 px-4 py-2 rounded-full">
                <Leaf className="w-5 h-5 text-green-600" />
                <span className="text-green-800 font-medium">Eco-Friendly</span>
              </div>
              <div className="flex items-center gap-2 bg-blue-100 px-4 py-2 rounded-full">
                <Clock className="w-5 h-5 text-blue-600" />
                <span className="text-blue-800 font-medium">24/7 Service</span>
              </div>
              <div className="flex items-center gap-2 bg-orange-100 px-4 py-2 rounded-full">
                <Award className="w-5 h-5 text-orange-600" />
                <span className="text-blue-800 font-medium">
                  Trusted Brand
                </span>
              </div>
            </div>
          </div>
          <div className="animate-fade-in-right">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-orange-400 to-red-400 rounded-3xl transform rotate-3"></div>
              <div className="relative bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl p-8 text-white">
                <h3 className="text-2xl font-bold mb-6">
                  Why Choose {brandName}?
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <Star className="w-4 h-4" />
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">Pan-India Presence</h4>
                      <p className="text-gray-300 text-sm">
                        Available in 40+ major cities across India
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <Clock className="w-4 h-4" />
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">Instant Booking</h4>
                      <p className="text-gray-300 text-sm">
                        Book your ride in minutes, anytime
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <MapPin className="w-4 h-4" />
                    </div>
                    <div>
                      <h4 className="font-semibold mb-1">Doorstep Delivery</h4>
                      <p className="text-gray-300 text-sm">
                        We deliver bikes right to your location
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CommonLayout>

      {/* Features Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-6 break-words">
              What Makes Us <span className="text-orange-500">Different</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We&apos;ve built India&apos;s most trusted bike rental platform
              with cutting-edge technology, premium service, and an unwavering
              commitment to customer satisfaction.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <FeatureCard
              icon={<Bike className="w-8 h-8 text-white" />}
              title="Premium Fleet"
              description="Well-maintained bikes and motorcycles from top brands, regularly serviced and upgraded for optimal performance and safety."
              delay="delay-100"
            />
            <FeatureCard
              icon={<Users className="w-8 h-8 text-white" />}
              title="Expert Support"
              description="Our dedicated customer support team is available 24/7 to help you with bookings, route planning, and any assistance you need."
              delay="delay-200"
            />
            <FeatureCard
              icon={<MapPin className="w-8 h-8 text-white" />}
              title="Cities"
              description="Extensive network across major Indian cities with convenient pickup and drop-off locations near you."
              delay="delay-300"
            />
            <FeatureCard
              icon={<Clock className="w-8 h-8 text-white" />}
              title="Flexible Rentals"
              description="Hourly, daily, weekly, or monthly rentals with competitive pricing starting from just ₹399 per day."
              delay="delay-100"
            />
            <FeatureCard
              icon={<Award className="w-8 h-8 text-white" />}
              title="Safety First"
              description="Comprehensive insurance, complimentary helmets, and 24/7 roadside assistance for your peace of mind."
              delay="delay-200"
            />
            <FeatureCard
              icon={<Leaf className="w-8 h-8 text-white" />}
              title="Sustainable Choice"
              description="Promoting eco-friendly transportation options to reduce carbon footprint and create cleaner cities."
              delay="delay-300"
            />
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      {/* <section className="py-20 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 text-white relative overflow-hidden">
        <div className="absolute inset-0">
          <svg
            viewBox="0 0 1440 320"
            className="absolute top-0 w-full h-auto transform rotate-180"
          >
            <path
              fill="rgba(59, 130, 246, 0.1)"
              d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,138.7C960,139,1056,117,1152,122.7C1248,128,1344,160,1392,176L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-6 break-words">
              Our Journey In Numbers
            </h2>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              These milestones reflect our commitment to serving customers
              across India with reliable, affordable transportation solutions.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center animate-fade-in-up delay-100">
              <div className="text-4xl md:text-6xl font-bold mb-2 text-orange-400">
                <Counter end={500} duration={2000} suffix="+" />
              </div>
              <p className="text-blue-200 text-lg">Happy Customers</p>
            </div>
            <div className="text-center animate-fade-in-up delay-200">
              <div className="text-4xl md:text-6xl font-bold mb-2 text-orange-400">
                <Counter end={2000} duration={200} suffix="+" />
              </div>
              <p className="text-blue-200 text-lg">Bikes Available</p>
            </div>
            <div className="text-center animate-fade-in-up delay-300">
              <div className="text-4xl md:text-6xl font-bold mb-2 text-orange-400">
                <Counter end={40} duration={2000} suffix="+" />
              </div>
              <p className="text-blue-200 text-lg">Cities Covered</p>
            </div>
            <div className="text-center animate-fade-in-up delay-500">
              <div className="text-4xl md:text-6xl font-bold mb-2 text-orange-400">
                <Counter end={1000} duration={2000} suffix="+" />
              </div>
              <p className="text-blue-200 text-lg">Kilometers Traveled</p>
            </div>
          </div>
        </div>
      </section> */}

      <style>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fade-in-left {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fade-in-right {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }
        
        .animate-fade-in-left {
          animation: fade-in-left 0.8s ease-out forwards;
        }
        
        .animate-fade-in-right {
          animation: fade-in-right 0.8s ease-out forwards;
        }
        
        .delay-100 {
          animation-delay: 0.1s;
        }
        
        .delay-200 {
          animation-delay: 0.2s;
        }
        
        .delay-300 {
          animation-delay: 0.3s;
        }
        
        .delay-500 {
          animation-delay: 0.5s;
        }
      `}</style>
    </div>
  );
};

export default AboutUsClient;
